import { call, put } from 'redux-saga/effects'
import { path } from 'ramda'
import PlanActions from 'Redux/PlanRedux'
import { BuildErrorMsg } from './ApiHelpers'

export function * onPlansRequest (api, action) {
  const resp = yield call(api.getPlans)
  if (resp.ok) {
    const subscription = yield call(api.getSubscriptions, action.teamId)
    const subscriptionPlanId = path(['plan', 'id'], subscription.data)
    const isSubscriptionActive = path(['status'], subscription.data) === 'active'
    if (isSubscriptionActive && subscriptionPlanId &&
        !resp.data.some(plan => plan.id === subscriptionPlanId)) {
      resp.data.unshift(subscription.data.plan)
    }
    const data = resp.data.map(plan => {
      return {
        ...plan,
        projects: 'Unlimited Projects',
        collaborators: 'Unlimited Collaborators',
        monthlyPrice: plan.monthlyPrice
          ? `$${plan.monthlyPrice}/month` : 'Custom Pricing',
        yearlyPrice: plan.yearlyPrice
          ? `$${plan.yearlyPrice}/month` : 'Custom Pricing',
        users: (plan.users || 'Unlimited') + ' Team Members',
        storage: (plan.storage ? plan.storage + ' GB' : 'Unlimited') + ' Storage',
        subscription: isSubscriptionActive && plan.id === subscriptionPlanId
          ? subscription.data : null
      }
    })
    yield put(PlanActions.plansListSuccess(data))
  } else {
    yield put(PlanActions.plansListFailure(BuildErrorMsg(resp)))
  }
}

export function * onPlansUpdateRequest (api, action) {
  // for update subscription code in future
}


// WEBPACK FOOTER //
// ./src/Sagas/PlanSagas.js